export enum PriorityLevelEnum {
    High = "1",
    Medium = "2",
    Low = "3",
}

// optional: Record type annotation guaranties that 
// all the values from the enum are presented in the mapping
export const PriorityLevelMapping: Record<PriorityLevelEnum, string> = {
    [PriorityLevelEnum.High]: "High",
    [PriorityLevelEnum.Medium]: "Medium",
    [PriorityLevelEnum.Low]: "Low",
};